import { useAppDispatch } from "../../../../redux/hooks";

import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import { adminRoutes } from "../../../../router/routesConstants";

import { DevicesNomenclatureListInterface } from "../../../../redux/interfaces/admin.interface";
import { getDownloadDevice } from "../../../../redux/api/admin.api";
import usePermissions from "../../../../router/usePermissions";
import userRoles from "../../../../constants/userRoles";
import withToggleStatusModal from "../hoc/withToggleStatusModal";

function DevicesNomenclatureActionButtons({
  itemId,
  crudData,
  tableContext,
  handleShowToggleModal,
}: {
  itemId: string;
  crudData: DevicesNomenclatureListInterface;
  tableContext: any;
  handleShowToggleModal?: (params: {
    device: DevicesNomenclatureListInterface;
    tableContext: any;
  }) => void;
}) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const isDeviceDisabled = crudData.status === 2;
  const canManageDevices = isAuthorized(userRoles.DEVICES_NOMENCLATURE_CREATE);

  const goToUpdateDeviceNomenclature = () => {
    if (itemId) {
      return `${adminRoutes.assignUser}?idDevice=${itemId}&model=${crudData.model}`;
    }
  };

  const goToDeviceNomenclatureHistory = () => {
    if (itemId) {
      return `${adminRoutes.deviceHistory}?idDevice=${itemId}&sn=${crudData.sn}`;
    }
  };

  const handleDownloadDevice = async () => {
    if (itemId) {
      await dispatch(getDownloadDevice({ idDevice: itemId }));
    }
  };

  const handleOpenToggleModal = () => {
    if (handleShowToggleModal) {
      handleShowToggleModal({
        device: crudData,
        tableContext: tableContext,
      });
    }
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={`${crudData.model} - ${crudData.sn}`}
      ariaLabel={`Actiuni pentru dispozitivul ${crudData.model} ${crudData.sn}`}
      items={[
        {
          id: "transfer",
          label: "Transfera",
          icon: "TRANSFER",
          tooltip: isDeviceDisabled
            ? "Dispozitivul este casat si nu poate fi transferat."
            : "Deschide atribuirea dispozitivului unui utilizator si atasarea documentului.",
          hidden: !canManageDevices,
          disabled: isDeviceDisabled,
          navigate: goToUpdateDeviceNomenclature(),
        },
        {
          id: "download",
          label: "Descarca document",
          icon: "DOWNLOAD",
          kind: "download",
          tooltip: isDeviceDisabled
            ? "Documentul nu poate fi descarcat pentru un dispozitiv casat."
            : !crudData.url
            ? "Dispozitivul nu are un document atasat."
            : "Descarca documentul atasat dispozitivului.",
          hidden: !canManageDevices,
          disabled: isDeviceDisabled || !crudData.url,
          onClick: handleDownloadDevice,
        },
        {
          id: "history",
          label: "Istoric",
          icon: "SPLIT_LIST",
          tooltip: "Deschide istoricul operatiunilor pentru acest dispozitiv.",
          hidden: !canManageDevices,
          navigate: goToDeviceNomenclatureHistory(),
        },
        {
          id: "toggle-status",
          dividerBefore: true,
          label: isDeviceDisabled ? "Restaureaza" : "Casare",
          icon: isDeviceDisabled ? "RESTORE" : "DELETE",
          color: isDeviceDisabled ? "primary" : "error",
          tooltip: isDeviceDisabled
            ? "Restaurarea dispozitivelor casate nu este disponibila."
            : "Deschide casarea dispozitivului si completarea motivului.",
          hidden: !canManageDevices,
          disabled: isDeviceDisabled,
          onClick: handleOpenToggleModal,
        },
      ]}
    />
  );
}

export default withToggleStatusModal(DevicesNomenclatureActionButtons);
